<template>
  <div>
    <v-stepper
      alt-labels
      v-model="stepNumber"
      class="elevation-0 stepper"
      :key="sections.length"
    >
      <!-- Stepper Header -->
      <v-stepper-header
        class="elevation-0"
        v-show="sectionNumberOfStepNeedHideStepHeader !== stepNumber"
      >
        <template v-for="section in sections">
          <v-stepper-step
            v-if="!section?.IsHideStepperTitle"
            color="accent"
            edit-icon="$complete"
            :editable="stepNumber > section.SectionNumber"
            :ripple="false"
            :key="`step-${section.SectionNumber}-header`"
            :step="section.SectionNumber"
            :complete="stepNumber > section.SectionNumber"
            @click="handleClick(section)"
          >
            {{ section.SectionTitle }}
          </v-stepper-step>
          <v-divider
            :key="section.SectionNumber"
            v-if="!isTerminus(section)"
          ></v-divider>
        </template>
      </v-stepper-header>

      <!-- Stepper Items -->
      <v-stepper-items>
        <template v-for="section in sections">
          <v-stepper-content
            class="pa-0"
            :key="`step-${section.SectionNumber}-content`"
            :step="section.SectionNumber"
          >
            <component
              :is="section.SectionControlType"
              :currentStep="stepNumber"
              :sections="sections"
              :section="section"
            ></component>
          </v-stepper-content>
        </template>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { APPLICATION_MODULE, STEPS_MODULE } from "@/store/types/module-types";
import ApplicationComplete from "@/views/StageApplication/ApplicationComplete";
import ApplicationQuestions from "@/views/StageApplication/ApplicationQuestions";
import CustomiseCover from "@/views/StageQuotation/CustomiseCover";
import D2CQuotationResults from "@/views/StageQuotation/D2CQuotationResults";
import QuotationQuestions from "@/views/StageQuotation/QuotationQuestions";
import QuotationResults from "@/views/StageQuotation/QuotationResults";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "StepperBase",
  components: {
    ApplicationQuestions,
    ApplicationComplete,
    QuotationQuestions,
    QuotationResults,
    CustomiseCover,
    D2CQuotationResults,
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState(STEPS_MODULE, ["currentStep"]),
    ...mapGetters(STEPS_MODULE, ["totalSteps"]),
    ...mapState(APPLICATION_MODULE, ["form"]),
    stepNumber: {
      get() {
        return this.currentStep;
      },
      set(value) {
        this.handleGoStep(value);
      },
    },
    sectionNumberOfStepNeedHideStepHeader() {
      const section = this.sections.filter(
        (section) => section.IsHideStepperHeader
      );
      return section[0]?.SectionNumber;
    },
  },
  methods: {
    ...mapActions(STEPS_MODULE, [
      "handleGoStep",
      "handleBackToYourQuote",
      "handleBack",
    ]),

    isTerminus(section) {
      const totalSectionNeedShowStepperTitle = this.sections.filter(
        (item) => !item.IsHideStepperTitle
      ).length;
      const isTheLastItem =
        section.SectionNumber >=
        this.sections[totalSectionNeedShowStepperTitle - 1].SectionNumber;
      return isTheLastItem;
    },
    handleClick(section) {
      if (section.isRedirectToYourQuotePage) {
        this.handleBackToYourQuote(section.SectionNumber);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-stepper {
  background: transparent;
}

.stepper {
  background: rgb(0, 255, 128);
}

:deep(.v-stepper__header) {
  max-width: 823px;
  margin: auto;
  margin-bottom: 5px !important;
}

:deep(.v-stepper__step--complete) + hr {
  border: solid 4px $stepper-active !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--active) + hr {
  border: solid 4px $stepper-inactive !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--inactive) ~ hr {
  border: solid 4px $stepper-inactive !important;
  margin: 44px -74px 0 !important;
}

:deep(.v-stepper__step--inactive.v-stepper__step--complete) ~ hr {
  border: solid 4px $stepper-active !important;
}
</style>
